<template>
  <div id="tabpanel-0" role="tabpanel" :aria-labelledby="'tab-0'" v-if="agree">
    <section class="section-accordion__wrap type-bullet type-top-narrow">
      <!-- 2. KISA 신고 이전 취약점 공개 및 외부 신고 여부 확인 -->
      <article class="section-accordion__item">
        <h3 class="section-accordion__header">
          <button
            type="button"
            class="section-accordion__btn"
            aria-controls="panel-2"
            id="accordion-trigger-2"
          >
            <span class="section-accordion__num" aria-hidden="true"></span>
            <span class="section-accordion__title"
              >Have you publicly disclosed the content of the vulnerability
              document on the internet or communicated it to the manufacturer
              before submitting the bug bounty Reporting to KISA?</span
            >
          </button>
        </h3>
        <div
          id="panel-2"
          class="section-accordion__panel"
          role="region"
          aria-labelledby="accordion-trigger-2"
        >
          <div
            class="section-accordion__content section-accordion__agree__wrap"
          >
            <div class="section-accordion__agree type-no-line">
              <p class="section-accordion__agree__desc"></p>
              <div class="chk__wrap">
                <label class="chk chk--circle">
                  <input
                    type="radio"
                    name="otherAgencyYn"
                    v-model="agree.otherAgencyYn"
                    :value="false"
                  />No
                </label>
                <label class="chk chk--circle">
                  <input
                    type="radio"
                    name="otherAgencyYn"
                    v-model="agree.otherAgencyYn"
                    :value="true"
                  />Yes
                </label>
              </div>
            </div>
            <div
              class="section-accordion__agree__inner"
              v-if="agree.otherAgencyYn"
            >
              <ul class="section-accordion__agree-form">
                <li class="section-accordion__agree-form__item">
                  <label
                    for="section-accordion__agree-target"
                    class="section-accordion__agree-form__label"
                    >Target</label
                  >
                  <input
                    id="section-accordion__agree-target"
                    class="section-accordion__agree-form__input"
                    type="text"
                    v-model="agree.otherAgencyName"
                    aria-label="agree-target"
                    required
                  />
                </li>
                <li class="section-accordion__agree-form__item">
                  <label
                    for="section-accordion__agree-date"
                    class="section-accordion__agree-form__label"
                    >Day</label
                  ><br />
                  <input
                    id="section-accordion__agree-date"
                    class="section-accordion__agree-form__input"
                    type="date"
                    placeholder="MM/DD/YYYY"
                    v-model="agree.otherAgencyDate"
                    aria-label="agree-date"
                    required
                  />
                </li>
              </ul>
            </div>
          </div>
        </div>
      </article>
      <!-- 4. 취약점 정보 활용 및 비밀유지 -->
      <article class="section-accordion__item">
        <h3 class="section-accordion__header">
          <button
            type="button"
            class="section-accordion__btn"
            aria-controls="panel-4"
            id="accordion-trigger-4"
          >
            <span class="section-accordion__num" aria-hidden="true"></span>
            <span class="section-accordion__title"
              >Utilization and Confidentiality of Vulnerability Reporting</span
            >
          </button>
        </h3>
        <div
          id="panel-4"
          class="section-accordion__panel"
          role="region"
          aria-labelledby="accordion-trigger-4"
        >
          <div
            class="section-accordion__content section-accordion__agree__wrap"
          >
            <div class="section-accordion__agree__inner">
              <p class="section-accordion__desc">
                The vulnerability reporting you provided will be utilized for
                developing security updates to address the vulnerabilities.
              </p>
              <div class="u-pt-15">
                <p class="section-accordion__desc">
                  The content of the vulnerability report could be a target of
                  security breaches and attacks. Therefore, we recommend not
                  disclosing the vulnerabilities to third parties, including
                  manufacturers, until the vulnerabilities are addressed in the
                  updated version. We also advise against disclosing the
                  vulnerabilities to any other organizations except for KISA.
                </p>
                <p class="section-accordion__desc">
                  - KISA Vulnerabilities: External non-disclosure recommended
                  until 90 days (3 months) after the manufacturer has issued a
                  security patch.
                </p>
                <p class="section-accordion__desc">
                  - Joint Operation Companies' Vulnerabilities: Permanent
                  non-disclosure recommended.
                </p>
              </div>
            </div>
          </div>
        </div>
      </article>
      <!-- 6. 정보통신망 이용촉진 및 정보보호 등에 관한 법률 위반행위 관련 안내 -->
      <article class="section-accordion__item">
        <h3 class="section-accordion__header">
          <button
            type="button"
            class="section-accordion__btn"
            aria-controls="panel-6"
            id="accordion-trigger-6"
          >
            <span class="section-accordion__num" aria-hidden="true"></span>
            <span class="section-accordion__title"
              >Information on Violations of the Act on Promotion of Information
              and Communications Network Utilization and Information
              Protection</span
            >
            <span class="section-accordion__chevron" aria-hidden="true">
              <i class="svg_icon icon_arrow_down"></i>
            </span>
          </button>
        </h3>
        <div
          id="panel-6"
          class="section-accordion__panel"
          role="region"
          aria-labelledby="accordion-trigger-6"
        >
          <div
            class="section-accordion__content section-accordion__agree__wrap"
          >
            <div class="section-accordion__agree__inner">
              <p class="section-accordion__desc">
                Engaging in the act of trying to discover vulnerabilities in
                operational websites or systems (servers, networks, security
                devices, etc.) without obtaining the agree of the information
                service provider and without proper authorization or by
                exceeding authorized access may be regarded as an intrusion into
                the information communication network. Such actions could result
                in legal consequences under South Korean law.
              </p>
              <div class="u-pt-15">
                <p class="section-accordion__desc">
                  <b
                    >「ACT ON PROMOTION OF INFORMATION AND COMMUNICATIONS
                    NETWORK UTILIZATION AND INFORMATION PROTECTION」</b
                  >
                </p>
              </div>
              <div class="u-pt-15">
                <p class="section-accordion__desc">
                  <span class="hightlight"
                    >- Article 48 (Prohibition on Intrusive Acts, etc. on
                    Information and Communications Network)</span
                  >
                  ① No one shall intrude on an information and communications
                  network without a rightful authority for access or beyond a
                  permitted authority for access.
                </p>
                <p class="section-accordion__desc">
                  <span class="hightlight"
                    >- Article 71 (Penalty Provisions)</span
                  >
                  Any of the following persons shall be punished by imprisonment
                  with labor for up to five years or by fine not exceeding 50
                  million won:
                </p>
                <p class="section-accordion__desc">
                  9. A person who intrudes on an information and communications
                  network in violation of Article 48 ①;
                </p>
                <p class="section-accordion__desc">
                  ② An attempt to commit a crime referred to in paragraph (1) 9
                  shall be punished.
                </p>
              </div>
            </div>
          </div>
        </div>
      </article>
    </section>
    <div class="btn__wrap type-bottom-board">
      <button
        type="button"
        class="btn btn--l btn--blue"
        @click="triggerClickToTab()"
      >
        Next
        <span aria-hidden="true"
          ><img src="@/assets/img/icon_arrow_right.svg" alt=""
        /></span>
      </button>
    </div>
  </div>
</template>

<script>
import reportHandler from "../../ReportHandler.js";
import { inject, ref, watch } from "vue";

export default {
  props: {
    modelValue: { type: Object, required: true },
  },
  mits: ["update:modelValue"],
  setup(props, { emit }) {
    const lodash = inject("lodash");

    // data 정의
    const agree = ref(lodash.cloneDeep(props.modelValue.agree));

    // methods 정의
    const triggerClickToTab = () => {
      const result = reportHandler.triggerClickToTabForeign(2, agree.value);
      if (!result) {
        return;
      }

      emit("changeTab", 2);
    };

    // watch 정의
    watch(
      agree,
      (newVal) => {
        emit("update:modelValue", {
          ...props.modelValue,
          agree: newVal,
        });
      },
      { deep: true }
    );

    // html에서 사용될 데이터 정의
    return {
      agree,
      triggerClickToTab,
    };
  },
};
</script>

<style>
.section-accordion__title {
  text-align: left;
  display: block;
}
</style>